import { useEffect, useRef, useState } from "react";
import "./App.css";
import HeaderPage from "./component/HeaderPage";
import html2canvas from "html2canvas";
import FilterComponent from "./component/FilterComponent";
import axios from "axios";
import ScheduleTable from "./component/ScheduleTable";
import { useNavigate, useParams } from "react-router-dom";
import PreviewPage from "./pages/PreviewPage";

function App() {
  const envClubs = import.meta.env.VITE_API_CLUB;
  const navigate = useNavigate();
  const { clubId: clubIdParam } = useParams();
  const [isLoading, setIsLoading] = useState({data: false, clone: false});
  const [showAlert, setShowAlert] = useState(false);
  const [showClone, setShowClone] = useState(false);
  const [toggleWeek, setToggleWeek] = useState(1);
  const [typeId, setTypeId] = useState(null);
  const [listType, setListType] = useState([]);

  const [clubs, setClubs] = useState([]);
  const [studios, setStudios] = useState([]);
  const [studioId, setStudioId] = useState(null);
  const [clubId, setClubId] = useState(clubIdParam ? clubIdParam : 20);
  const [schedules, setSchedules] = useState([]);
  const cloneRef = useRef(null);
  const [selectedStudio, setSelectedStudio] = useState(null);
  const [selectedClub, setSelectedClub] = useState(null);
  const [disabledIds, setDisabledIds] = useState([11, 13, 66, 114, 144, 142, 121, 112, 110, 108, 107]);
  const getTypes = async () => {
    try {
      const response = await axios.get(`type?type=0`);

      setListType(response.data.data);
    } catch (error) {
      console.error("Error fetching types:", error);
    }
  };

  const getClubs = async () => {
    setIsLoading({...isLoading, data: true});
    const params = new URLSearchParams({
      page: 1,
      per_page: 200,
    });

    disabledIds.forEach(async (id) => {
      params.append('not_in_id', id);
    });

    try {
      setClubs([]);
      setStudios([]);
      const response = await axios.get(envClubs, {
        params: params,
        headers: {
          'Content-Type': 'application/json',
        },
      });

      // console.log(response.data.data, 'ini response clubs');
      // console.log(response.data, 'ini response meta');

      setClubs(response.data.data);

      // If clubId is provided in URL, automatically select it
      if (clubIdParam) {
        const parsedClubId = parseInt(clubIdParam, 10);
        setClubId(parsedClubId);
        await getStudios(parsedClubId);
      }
    } catch (error) {
      console.error("Error fetching clubs:", error);
    } finally {
      setIsLoading({...isLoading, data: false});
    }
  };

  const getStudios = async (item) => {
    setStudios([]);
    try {
      const response = await axios.get(`studio?club_id=${item}`);

      setStudios(response.data.data);
    } catch (error) {
      console.error("Error fetching studios:", error);
    }
  };

  const getSchedules = async () => {
    setIsLoading({...isLoading, data: true});
    try {
      const params = {
        type: 0,
        club_id: clubId,
        studio_id: studioId,
        page: toggleWeek,
        type_id: typeId,
      };
      const response = await axios.get(``, {
        params: params,
      });

      console.log(response.data.data, 'ini response schedules');
      setSelectedStudio(studios.find((studio) => studio.id == studioId));
      setSelectedClub(clubs.find((club) => club.id == clubId));
      setSchedules(response.data.data || []);

    } catch (error) {
      console.error("Error fetching schedules:", error);
      setSchedules([]);
    } finally {
      setIsLoading({...isLoading, data: false});
    }
  };

  const handleDownloadImage = async () => {
    if (!clubId) {
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 2500);
    } else {
      try {
        setIsLoading({...isLoading, clone: true});
        setShowClone(true);

        // Wait for content to render
        await new Promise((resolve) => setTimeout(resolve, 500));

        if (!cloneRef.current) {
          console.error("Clone reference not found");
          return;
        }
        await document.fonts.ready;
        const canvas = await html2canvas(cloneRef.current, {
          backgroundColor: null,
          scale: 2, // Increase quality
          logging: true, // Enable logging for debugging
          useCORS: true, // Enable CORS for images
        });

        const link = document.createElement("a");
        const clubName =
          clubs.find((club) => club.id == clubId)?.name || "club";
        link.download = `${clubName}-schedule.png`;
        link.href = canvas.toDataURL("image/png");
        link.click();
      } catch (error) {
        console.error("Error capturing image:", error);
      } finally {
        setShowClone(false);
        setIsLoading({...isLoading, clone: false});
      }
    }
  };

  const handleNavigateToPreview = () => {
    navigate("/preview", {
      state: {
        schedules,
        listType,
        selectedClub,
        selectedStudio,
      },
    });
  };

  // const handleClassClick = (classData, day, hour) => {
  //   console.log("Class clicked:", { classData, day, hour });
  //   // You can add your custom logic here, such as:
  //   // - Opening a modal with class details
  //   // - Navigating to a class detail page
  //   // - Showing additional information
  //   // - Adding to favorites, etc.
    
  //   // Example: Show an alert with class information
  //   if (classData && classData.length > 0) {
  //     const classInfo = classData[0]; // Get the first class in the time slot
  //     alert(`Class: ${classInfo.class_name}\nInstructor: ${classInfo.instruktur_name}\nTime: ${classInfo.start_time} - ${classInfo.end_time}\nDay: ${day}`);
  //   }
  // };

  useEffect(() => {
    getClubs();
    getTypes();
  }, []);

  useEffect(() => {
    if (clubId) {
      getSchedules();
    }
  }, [toggleWeek, typeId, clubId, studioId]);

  return (
    <div>
      {showAlert && (
        <div
          className="alert alert-warning alert-dismissible fade show mx-3 mt-3"
          role="alert"
        >
          Please select a club and studio first.
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowAlert(false)}
            aria-label="Close"
          ></button>
        </div>
      )}
      <div className="mx-2 my-3 gap-4">
        <HeaderPage />
        <div className="d-flex justify-content-end px-2">
          <button
            type="button"
            className="btn btn-outline btn-download mb-3 me-2"
            style={{ display: "none" }}
            onClick={handleNavigateToPreview}
          >
            Preview
          </button>
          <button
            type="button"
            className="btn btn-outline btn-download mb-3"
            onClick={handleDownloadImage}
          >
            {isLoading?.clone ? (
              <span
                className="spinner-border spinner-border-sm me-2"
                aria-hidden="true"
              ></span>
            ) : (
              <i
                className="bi bi-download me-2"
                style={{ fontSize: "1rem" }}
              ></i>
            )}
            Download
          </button>
        </div>
      </div>

      <div className=" my-3 gap-4">
        <FilterComponent
          clubs={clubs}
          studios={studios}
          setStudios={setStudios}
          clubId={clubId}
          studioId={studioId}
          setStudioId={setStudioId}
          setClubId={setClubId}
          getStudios={getStudios}
          getSchedules={getSchedules}
          setToggleWeek={setToggleWeek}
          listType={listType}
          setTypeId={setTypeId}
        />
      </div>

      <div className="mx-1 my-3 gap-4">
        <ScheduleTable schedules={schedules}/>
      </div>
      <div className="warning-text mx-1 text-center">
        <span>
          *untuk informasi lebih lanjut silakan hubungi membership consultant
          kami di seluruh cabang FTL Gym
        </span>
      </div>

      {showClone && (
        <div
          ref={cloneRef}
          className="mx-2 my-3 gap-4"
          style={{
            position: "absolute",
            left: "-9999px",
            top: 0,
            width: "1400px",
            zIndex: -1,
            background: "white",
          }}
        >
          <PreviewPage
            schedules={schedules}
            listType={listType}
            selectedClub={selectedClub}
            selectedStudio={selectedStudio}
          />
        </div>
      )}
    </div>
  );
}

export default App;
